/**
 *
 *  Organizations/Show/Integrations
 *
 */

import React, { useMemo } from 'react'

// NPM Libraries
import PropTypes from 'prop-types'
import Toggle from 'react-toggle'
import styled from '@emotion/styled'

// GraphQL
import useQuery from 'components/UseQuery'
import { gql, useMutation } from '@apollo/client'

// Utils
import { titleize } from 'components/utils'

export const ToggleContainer = styled.div`
	.react-toggle {
		transform: scale(0.75);
	}
`

const GET_USERS_INTEGRATIONS = gql`
	query getUsersIntegrations($id: ID!) {
		organization(id: $id) {
			id
			users_integrations
		}
	}
`

const UPDATE_ORGANIZATION = gql`
	mutation updateOrganization($id: ID!, $users_integrations: JSON) {
		updateOrganization(input: { id: $id, users_integrations: $users_integrations }) {
			organization {
				id
				name
			}
		}
	}
`

function Integrations({ organization_id }) {
	const {
		data: { organization },
		loading,
		refetch,
	} = useQuery(GET_USERS_INTEGRATIONS, {
		variables: { id: organization_id },
		default_data: {
			organization: { users_integrations: {} },
		},
	})

	const [updateOrganization] = useMutation(UPDATE_ORGANIZATION, { onCompleted: refetch })

	const handleUpdateIntegration = (integration, value) => {
		const new_list = { ...organization.users_integrations }

		new_list[integration] = value

		updateOrganization({
			variables: {
				id: organization_id,
				users_integrations: new_list,
			},
		})
	}

	const integrations_list = useMemo(() => Object.keys(organization.users_integrations).sort(), [organization])

	return (
		<main className="container-fluid">
			<div className="row">
				<div className="col-md-5 col-12 mb-3">
					<div className="card px-4 py-3">
						<h3>Users Integrations</h3>
						<p>Enable or disable the integrations offered to Users within the Organization.</p>

						<div className="border border-bottom-0">
							{integrations_list.map((integration) => (
								<div
									key={integration}
									className="d-flex justify-content-between px-3 py-2 border-bottom"
								>
									<span>{titleize(integration.toLowerCase())}</span>

									<ToggleContainer>
										<Toggle
											value={organization.users_integrations[integration]}
											checked={organization.users_integrations[integration]}
											onChange={() =>
												handleUpdateIntegration(
													integration,
													!organization.users_integrations[integration],
												)
											}
											disabled={loading}
										/>
									</ToggleContainer>
								</div>
							))}
						</div>
					</div>
				</div>
			</div>
		</main>
	)
}

Integrations.propTypes = {
	organization_id: PropTypes.string,
}

export default Integrations
